export const cashlessTopUpByEventIdCustom = /* GraphQL */ `
  query CashlessTopUpByEventID(
    $eventId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCashlessTopUpFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cashlessTopUpByEventID(
      eventId: $eventId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        amount
        paymentMethod
        isVoided
        status
        type
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const cashlessTransactionByEventIdCustom = /* GraphQL */ `
  query CashlessTransactionByEventID(
    $eventId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCashlessTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cashlessTransactionByEventID(
      eventId: $eventId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderTotal
        paidAmount
        paymentStatus
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const cashlessTopUpByDeletedCustom = /* GraphQL */ `
  query CashlessTopUpByDeleted(
    $deleted: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCashlessTopUpFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cashlessTopUpByDeleted(
      deleted: $deleted
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        operation
        amount
        availableBalance
        paymentChannel
        paymentMethod
        isVoided
        guestId
        guestPhoneNumber
        guestEmail
        bookingId
        invitationId
        ticketType
        booking {
          id
          balance
        }
        invitation {
          id
          balance
        }
        guest {
          email
        }
        eventId
        eventName
        status
        type
        syncOperationId
        deleted
        guestName
        createdAt
        createdByID
        createdByName
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const cashlessTransactionsByDeletedCustom = /* GraphQL */ `
  query CashlessTransactionsByDeleted(
    $deleted: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCashlessTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cashlessTransactionsByDeleted(
      deleted: $deleted
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        pos
        checkNumber
        orderTotal
        paidAmount
        paymentStatus
        guestId
        guestPhoneNumber
        guestEmail
        guest {
          id
          name
          email
          phone_number
        }
        guestName
        type
        bookingId
        invitationId
        eventId
        event {
          id
          name
        }
        orderedItems {
          id
          name
          quantity
          price
          __typename
        }
        syncOperationId
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

/**
 * Lean version of `bookingByEventId` for the Bookings LIST view only.
 *
 * The generated query resolves guest, mainGuest and lastGuest with every
 * Guest field, the full event (incl. its tickets/gates/invitationLimit
 * connections), the full eventTicket (with waves) and rejectionReason: up to
 * ~9 nested resolver calls per row. The list rows (NewBookingRow,
 * TransferedBookingsRow) only need the fields below. Details pages, status
 * changes and exports always re-fetch the full booking (getBooking /
 * bookingByEventId), so they are unaffected.
 */
export const bookingByEventIdListing = /* GraphQL */ `
  query BookingByEventIdListing(
    $bookingEventId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingByEventId(
      bookingEventId: $bookingEventId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        overallStatus
        bookingGuestId
        bookingMainGuestId
        mainBookingId
        bookingEventId
        bookingEventTicketId
        guest {
          id
          name
          email
          phone_number
          gender
          guest_avatar
          guestGroupID
          guestGroupName
          isVerified
          totalEvents
          last_attended_event_Name
          faceBookProfileLink
          instagramProfileLink
          flags
          birthdate
          __typename
        }
        mainGuest {
          id
          name
          email
          phone_number
          gender
          guest_avatar
          guestGroupID
          guestGroupName
          isVerified
          flags
          connections
          birthdate
          totalEvents
          avg_spend
          __typename
        }
        event {
          id
          name
          __typename
        }
        wave
        waveId
        isMainGuest
        orderId
        statusUpdatedByID
        statusUpdatedByName
        statusUpdatedAt
        paymentExpirationAt
        specialNeed
        phone_number
        guestName
        hasNotRegisteredGuest
        deleted
        createdAt
        createdByID
        createdByName
        rejectionComment
        isPaid
        isTransfered
        isPendingTransfer
        lastGuestId
        lastGuest {
          id
          name
          gender
          guest_avatar
          __typename
        }
        lastMainGuestId
        origin
        updatedAt
        _version
        _deleted
        _lastChangedAt
        bookingRejectionReasonId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

/**
 * Same lean selection as bookingByEventIdListing, but served by the
 * `bookingsByEventAndStatus` GSI (PK bookingEventId, SK status).
 * Requires the schema index to be deployed (amplify push); the list fetch
 * falls back to bookingByEventIdListing when the field is unknown.
 */
export const bookingsByEventAndStatusListing = /* GraphQL */ `
  query BookingsByEventAndStatusListing(
    $bookingEventId: ID!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingsByEventAndStatus(
      bookingEventId: $bookingEventId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        overallStatus
        bookingGuestId
        bookingMainGuestId
        mainBookingId
        bookingEventId
        bookingEventTicketId
        guest {
          id
          name
          email
          phone_number
          gender
          guest_avatar
          guestGroupID
          guestGroupName
          isVerified
          totalEvents
          last_attended_event_Name
          faceBookProfileLink
          instagramProfileLink
          flags
          birthdate
          __typename
        }
        mainGuest {
          id
          name
          email
          phone_number
          gender
          guest_avatar
          guestGroupID
          guestGroupName
          isVerified
          flags
          connections
          birthdate
          totalEvents
          avg_spend
          __typename
        }
        event {
          id
          name
          __typename
        }
        wave
        waveId
        isMainGuest
        orderId
        statusUpdatedByID
        statusUpdatedByName
        statusUpdatedAt
        paymentExpirationAt
        specialNeed
        phone_number
        guestName
        hasNotRegisteredGuest
        deleted
        createdAt
        createdByID
        createdByName
        rejectionComment
        isPaid
        isTransfered
        isPendingTransfer
        lastGuestId
        lastGuest {
          id
          name
          gender
          guest_avatar
          __typename
        }
        lastMainGuestId
        origin
        updatedAt
        _version
        _deleted
        _lastChangedAt
        bookingRejectionReasonId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

/**
 * Lean events list for the app-wide event picker / default-event rule
 * (see hooks/useEventsLookup.ts). The generated listEvents selects every
 * Event field plus nested connections; the selector only needs these.
 */
export const listEventsLookup = /* GraphQL */ `
  query ListEventsLookup(
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        startDate
        endDate
        published
        deleted
        createdAt
      }
      nextToken
    }
  }
`;

/**
 * Scanner dashboard: only the TicketsScan fields used by the breakdowns
 * (generated TicketScansByEventId also returns guestAvatar, guestName, ...).
 */
export const ticketScansByEventIdLean = /* GraphQL */ `
  query TicketScansByEventIdLean(
    $eventId: ID!
    $scannedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTicketsScanFilterInput
    $limit: Int
    $nextToken: String
  ) {
    TicketScansByEventId(
      eventId: $eventId
      scannedAt: $scannedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scannedById
        scannedByName
        scannedAt
        updatedAt
        bookingId
        invitationId
        ticketType
        gateName
      }
      nextToken
    }
  }
`;

/**
 * Ids only (used to count / match redeemed bookings). The generated
 * bookingByEventId selects ~390 lines incl. nested guest/event/ticket
 * resolvers per row.
 */
export const bookingIdsByEventId = /* GraphQL */ `
  query BookingIdsByEventId(
    $bookingEventId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingByEventId(
      bookingEventId: $bookingEventId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;

/** Ids only (used to count / match used invitations). */
export const invitationIdsByEventId = /* GraphQL */ `
  query InvitationIdsByEventId(
    $invitationEventId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invitationByEventId(
      invitationEventId: $invitationEventId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;

/**
 * Overview gender card: gender per paid booking. The ticket type is mapped
 * from `bookingEventTicketId` with the event's tickets (one small query)
 * instead of an `eventTicket` resolver call per booking.
 */
export const bookingGendersByEventId = /* GraphQL */ `
  query BookingGendersByEventId(
    $bookingEventId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingByEventId(
      bookingEventId: $bookingEventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        bookingEventTicketId
        guest {
          gender
        }
      }
      nextToken
    }
  }
`;

/** Ticket id -> type for one event (Overview gender card). */
export const eventTicketTypesByEventId = /* GraphQL */ `
  query EventTicketTypesByEventId($id: ID!) {
    getEvent(id: $id) {
      id
      tickets(limit: 1000) {
        items {
          id
          type
        }
        nextToken
      }
    }
  }
`;

/** Type of one ticket (fallback when a booking's ticket is not in the event's list). */
export const eventTicketTypeById = /* GraphQL */ `
  query EventTicketTypeById($id: ID!) {
    getEventTicket(id: $id) {
      id
      type
    }
  }
`;

/**
 * Same fields as cashlessTopUpByDeletedCustom, served by the event index
 * (cashlessTopUpByEventID) so one event is read instead of every top-up.
 */
export const cashlessTopUpByEventIdList = /* GraphQL */ `
  query CashlessTopUpByEventIdList(
    $eventId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCashlessTopUpFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cashlessTopUpByEventID(
      eventId: $eventId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        operation
        amount
        availableBalance
        paymentChannel
        paymentMethod
        isVoided
        guestId
        guestPhoneNumber
        guestEmail
        bookingId
        invitationId
        ticketType
        booking {
          id
          balance
        }
        invitation {
          id
          balance
        }
        guest {
          email
        }
        eventId
        eventName
        status
        type
        syncOperationId
        deleted
        guestName
        createdAt
        createdByID
        createdByName
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

/**
 * Same fields as cashlessTransactionsByDeletedCustom, served by the event
 * index (cashlessTransactionByEventID).
 */
export const cashlessTransactionByEventIdList = /* GraphQL */ `
  query CashlessTransactionByEventIdList(
    $eventId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCashlessTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cashlessTransactionByEventID(
      eventId: $eventId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        pos
        checkNumber
        orderTotal
        paidAmount
        paymentStatus
        guestId
        guestPhoneNumber
        guestEmail
        guest {
          id
          name
          email
          phone_number
        }
        guestName
        type
        bookingId
        invitationId
        eventId
        event {
          id
          name
        }
        orderedItems {
          id
          name
          quantity
          price
          __typename
        }
        syncOperationId
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

/**
 * Booking exports: only the fields the export sheets use (the full
 * bookingByEventId selection pulled every nested object per booking).
 */
const BOOKING_EXPORT_FIELDS = /* GraphQL */ `
        id
        status
        overallStatus
        isPaid
        isMainGuest
        phone_number
        guestName
        origin
        paymentMethod
        redeemed
        waveId
        bookingEventTicketId
        deleted
        createdAt
        guest {
          id
          name
          email
          phone_number
          __typename
        }
        eventTicket {
          id
          type
          __typename
        }
        __typename
`;

export const bookingByEventIdExport = /* GraphQL */ `
  query BookingByEventIdExport(
    $bookingEventId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingByEventId(
      bookingEventId: $bookingEventId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {${BOOKING_EXPORT_FIELDS}}
      nextToken
      __typename
    }
  }
`;

/** Same as bookingByEventIdExport, served by the bookingsByEventAndStatus GSI. */
export const bookingsByEventAndStatusExport = /* GraphQL */ `
  query BookingsByEventAndStatusExport(
    $bookingEventId: ID!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingsByEventAndStatus(
      bookingEventId: $bookingEventId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {${BOOKING_EXPORT_FIELDS}}
      nextToken
      __typename
    }
  }
`;

/** Invitations for the booking exports (fields the sheets use only). */
export const invitationByEventIdExport = /* GraphQL */ `
  query InvitationByEventIdExport(
    $invitationEventId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invitationByEventId(
      invitationEventId: $invitationEventId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        email
        phone_number
        used
        deleted
        createdAt
        eventTicket {
          id
          type
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;

/**
 * Event preview (attendees list, custom notification, bulk payment
 * deadline): the booking fields those use only.
 */
export const bookingByEventIdPreview = /* GraphQL */ `
  query BookingByEventIdPreview(
    $bookingEventId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingByEventId(
      bookingEventId: $bookingEventId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        isPaid
        phone_number
        guestName
        deleted
        createdAt
        guest {
          id
          name
          email
          phone_number
          gender
          guest_avatar
          isVerified
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
